import { rgbaColor } from '../../../../../utils/colorUtils';
import { CHART_BUCKETS_RECENT_START_INDEX } from '../../../../dashboard/overdue-statistic/overdueChartConstants';

const resolveColor = (token, getThemeColor) => (token.startsWith('#') ? token : getThemeColor(token));

/** 超期区间（前 3 段）：红色系 */
const OVERDUE_BUCKET_OVERDUE_TOKENS = ['#C41E3A', 'danger', '#FF6B35'];

/** 近期区间（后 7 段）：与仪表盘超期柱状图一致 */
const OVERDUE_BUCKET_RECENT_TOKENS = ['warning', 'primary', '#4A90E2', '#5BC0DE', '#6BB6FF', '#7ED321', 'success'];

const BUCKET_FILL_OPACITIES = [0.8, 0.75, 0.7, 0.65, 0.65, 0.6, 0.58, 0.55, 0.5, 0.45];

const OVERDUE_RANK_TOKENS = ['#C41E3A', 'danger', '#E63757', '#DC3545', '#FF6B35', '#F87171', '#EF4444', '#FB7185', '#B91C1C', '#FCA5A5'];

export const OVERDUE_PAYMENT_TYPE_COLOR_TOKEN = {
	delivery: '#C41E3A',
	accept: '#FF6B35',
};

export const resolveBucketChartColor = (bucketIndex, getThemeColor) => {
	const tokens = [...OVERDUE_BUCKET_OVERDUE_TOKENS, ...OVERDUE_BUCKET_RECENT_TOKENS];
	const token = tokens[bucketIndex] ?? tokens[tokens.length - 1];
	const opacity = BUCKET_FILL_OPACITIES[bucketIndex] ?? BUCKET_FILL_OPACITIES[BUCKET_FILL_OPACITIES.length - 1];
	return rgbaColor(resolveColor(token, getThemeColor), opacity);
};

export const resolveBucketChartStrokeColor = (bucketIndex, getThemeColor) => {
	const tokens = [...OVERDUE_BUCKET_OVERDUE_TOKENS, ...OVERDUE_BUCKET_RECENT_TOKENS];
	return resolveColor(tokens[bucketIndex] ?? tokens[tokens.length - 1], getThemeColor);
};

export const parseOverdueBucketIndex = (key) => {
	const match = /^bucket-(\d+)$/.exec(key ?? '');
	return match ? Number(match[1]) : null;
};

export const resolveOverdueRankColor = (index, getThemeColor) => {
	const token = OVERDUE_RANK_TOKENS[index % OVERDUE_RANK_TOKENS.length];
	return rgbaColor(resolveColor(token, getThemeColor), 0.92 - (index % OVERDUE_RANK_TOKENS.length) * 0.04);
};

export const resolveOverduePaymentTypeColor = (key, getThemeColor) =>
	resolveColor(key === 'delivery' ? OVERDUE_PAYMENT_TYPE_COLOR_TOKEN.delivery : OVERDUE_PAYMENT_TYPE_COLOR_TOKEN.accept, getThemeColor);

export const resolveDefaultPaymentTypeColor = (key, getThemeColor) =>
	getThemeColor(key === 'delivery' ? 'primary' : 'warning');

export const resolveOverdueAccentColor = (getThemeColor) => getThemeColor('danger');

export const resolveDefaultAccentColor = (getThemeColor) => getThemeColor('primary');

export const resolveOverdueOtherColor = (getThemeColor) => rgbaColor(getThemeColor('danger'), 0.42);

export const isOverdueBucketIndex = (index) => index < CHART_BUCKETS_RECENT_START_INDEX;
